import React, { useEffect } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../../config/authConfig";
import "./SignInView.css";
import BaseButton from "../../components/Base/BaseButton/BaseButton";
import Headline from "../../components/Headline/Headline";
import { useNavigate } from "react-router-dom";
import { servicesConfig } from "../../config/serviceDashboardConfig";
import { IS_DACHSER } from "../../constants";


const SignInPage = () => {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const services = Object.values(servicesConfig);

    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated && IS_DACHSER){
            navigate(`/${services[0].id}/dashboard`)
        }else if (isAuthenticated) {
            navigate("/overview");
        }
    }, [isAuthenticated, navigate, services]);

    const handleLogin = () => {
        instance.loginPopup(loginRequest).catch((e) => {
            console.error("Login error", e);
        });
    };

    return (
        <div className="signin-container">
            <div className="signin-card">
                <Headline
                    title="FA-Services Dashboard"
                    subtitle="Please sign in using your Microsoft account to continue."
                />
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                    alt="Microsoft Logo"
                    className="signin-logo"
                />
                <h2 className="signin-title">Sign in to your account</h2>
                <p className="signin-subtitle">Secure Microsoft login powered by Azure AD</p>

                <BaseButton variant="primary" onClick={handleLogin} className="signin-button">
                    Sign in with Microsoft
                </BaseButton>
            </div>
        </div>

    );

};

export default SignInPage;
